const Search = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M23.6857 22.9401L15.4323 14.6701C16.6206 13.1831 17.335 11.3001 17.335 9.24706C17.335 4.44906 13.4547 0.560059 8.6675 0.560059C3.88027 0.560059 0 4.44906 0 9.24706C0 14.0451 3.88027 17.9341 8.6675 17.9341C11.0461 17.9341 13.2003 16.9721 14.7668 15.4171L22.9793 23.6481L23.6847 22.9411L23.6857 22.9401ZM8.6675 16.9331C4.43801 16.9331 0.997755 13.4851 0.997755 9.24606C0.997755 5.00706 4.43801 1.56006 8.6675 1.56006C12.897 1.56006 16.3372 5.00806 16.3372 9.24706C16.3372 13.4861 12.897 16.9341 8.6675 16.9341V16.9331Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Search;
